import { format, parseISO } from "date-fns";

/**
 * Formats a date string to a human-readable format
 *
 * @param date - The date string to format
 * @param formatString - The format string to use (defaults to "MM/dd/yy p")
 * @returns The formatted date string
 */
export const formatDate = (
    date: string,
    formatString: string = "MM/dd/yy p"
) => {
    const parsedDate = parseISO(date);
    return format(parsedDate, formatString);
};
